import './header/index';
import './components/footer';
import './banners';

import Lightbox from './lightbox';
import { smoothScrollTo, equalizeHeights } from './utils/dom';

// Attach common utilities to window for use in inline scripts
window.smoothScrollTo = smoothScrollTo;
window.equalizeHeights = equalizeHeights;

// Initialize Callback Queue for Splide
window.SplideReady = window.SplideReady || [];

/**
 * Dynamic Import for Splide
 * Only loads the library if a slider exists on the current page.
 */
if (document.querySelector('.splide')) {
    import('./splide').then(({ default: SplideManager }) => {
        window.SplideManager = SplideManager;
        window.Splide = SplideManager.Splide;

        // Attach extensions to the Splide constructor
        (window.Splide as { Extensions?: unknown }).Extensions = SplideManager.extensions;

        // Auto-initialize sliders based on data-attributes
        SplideManager.autoInit();

        // Process any callbacks that were pushed before the library finished loading
        if (Array.isArray(window.SplideReady)) {
            window.SplideReady.forEach((cb) => {
                cb(SplideManager);
            });
        }

        // Redefine push to execute callbacks immediately from now on
        window.SplideReady = {
            push: (cb: (manager: unknown) => void) => {
                cb(SplideManager);
            }
        };
    });
}

// Initialize Lightbox and expose to window for dynamic content
window.Lightbox = Lightbox;
Lightbox.init();

/**
 * Password Validation Logic
 */
function validatePassword(input: HTMLInputElement): void {
    if (isValidPassword(input.value) === false) {
        input.classList.add('is-invalid');
        // Setting a custom validity string prevents form submission
        input.setCustomValidity('invalid form');
    } else {
        input.classList.remove('is-invalid');
        input.setCustomValidity('');
    }
}

function isValidPassword(password: string): boolean {
    if (password.length < 8) {
        return false;
    }

    const hasNumber = /[0-9]/.test(password);
    const hasLetter = /[a-zA-Z]/.test(password);

    if (hasNumber === true && hasLetter === true) {
        return true;
    }

    return false;
}

/**
 * Checks if two password fields match
 */
function matchPasswords(input1: HTMLInputElement, input2: HTMLInputElement): void {
    if (input1.value !== input2.value) {
        input1.classList.add('is-invalid');
        input1.setCustomValidity('invalid form');
    } else {
        input1.classList.remove('is-invalid');
        input1.setCustomValidity('');
    }
}

// Attach validation to window so they can be called from HTML onchange/onblur
window.validatePassword = validatePassword;
window.isValidPassword = isValidPassword;
window.matchPasswords = matchPasswords;